import BasePage from '@/base/page'

// eslint-disable-next-line no-unused-vars

export default class Blog extends BasePage {

}
